import React from "react";
import { FrameView } from "components/FrameView/FrameView";

export const PlanSER = () => {
  return (
    <FrameView
      title="PlanSER"
      src="https://bicloud.smartkokshetau.kz/public/dashboards/33"
    />
  );
};
